import type { SceneSummary } from './types';

export function sceneSummaryId(scene: SceneSummary): string {
  return scene.sceneId || scene.id || '';
}

export function mergeSceneFavorites(scenes: readonly SceneSummary[], favoriteSceneIds: readonly string[]): SceneSummary[] {
  const favorites = new Set(favoriteSceneIds);
  return scenes.map((scene) => ({ ...scene, favorite: favorites.has(sceneSummaryId(scene)) }));
}

export function updateSceneFavorite(
  scenes: readonly SceneSummary[],
  sceneId: string,
  favorite: boolean,
): SceneSummary[] {
  return scenes.map((scene) => sceneSummaryId(scene) === sceneId ? { ...scene, favorite } : scene);
}

/** Favorites form the first group; the lower group contains the remaining scenes, so a card moves once. */
export function groupScenesByFavorite(scenes: readonly SceneSummary[], query = ''): {
  favorites: SceneSummary[];
  all: SceneSummary[];
} {
  const needle = query.trim().toLocaleLowerCase();
  const visible = needle
    ? scenes.filter((scene) => scene.name.toLocaleLowerCase().includes(needle))
    : [...scenes];
  return {
    favorites: visible.filter((scene) => scene.favorite === true),
    all: visible.filter((scene) => scene.favorite !== true),
  };
}
